import { AppShell } from "../components/AppShell";
import { navigate, useLocation } from "../lib/router";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { api, ApiError } from "../lib/api";
import { Login } from "../pages/Login";
import { Dashboard } from "../pages/Dashboard";
import { QuestionBank } from "../pages/QuestionBank";
import { QuestionStudio } from "../pages/QuestionStudio";
import { LiveGame } from "../pages/LiveGame";
import { AuditLog, Groups, Leaderboard, Settings } from "../pages/Operations";
import { Admins } from "../pages/Admins";

function permissionForPath(pathname: string): string {
  if (pathname === "/questions/new") return "question.create";
  if (pathname === "/questions") return "question.view";
  if (pathname === "/live") return "game.start";
  if (pathname === "/groups") return "group.manage";
  if (pathname === "/leaderboard") return "leaderboard.view";
  if (pathname === "/audit") return "audit.view";
  if (pathname === "/admins") return "admin.manage";
  if (pathname === "/settings") return "settings.manage";
  return "dashboard.view";
}

export function App() {
  const auth = useQuery({ queryKey: ["auth"], queryFn: api.me, retry: false });
  const { pathname } = useLocation();
  const permission = permissionForPath(pathname);
  const allowed = Boolean(auth.data?.permissions.includes(permission));
  const defaultPath = auth.data?.permissions.includes("dashboard.view") ? "/" : "/questions/new";
  useEffect(() => {
    if (auth.data && !allowed) navigate(defaultPath, true);
  }, [allowed, auth.data, defaultPath]);
  if (auth.isLoading) return <div className="app-boot"><span className="brand-mark"><span>SD</span></span><p>Menyiapkan control center...</p></div>;
  if (auth.error instanceof ApiError && auth.error.status === 401) return <Login />;
  if (!auth.data || !allowed) return <div className="app-boot"><span className="brand-mark"><span>SD</span></span><p>Mengarahkan ke halaman yang diizinkan...</p></div>;
  const page = pathname === "/questions/new" ? <QuestionStudio canPublish={auth.data.permissions.includes("question.publish")} canSendToGroup={auth.data.permissions.includes("question.send")} canViewBank={auth.data.permissions.includes("question.view")} />
    : pathname === "/questions" ? <QuestionBank />
    : pathname === "/live" ? <LiveGame />
    : pathname === "/groups" ? <Groups />
    : pathname === "/leaderboard" ? <Leaderboard />
    : pathname === "/audit" ? <AuditLog />
    : pathname === "/admins" ? <Admins />
    : pathname === "/settings" ? <Settings />
    : <Dashboard />;
  return <AppShell user={auth.data}>{page}</AppShell>;
}
